import { BoxContainer, Text } from "@volumental/common";
import type { JSX } from "react";
import { useTranslation } from "react-i18next";

export function ErrorBox(): JSX.Element {
  const { t } = useTranslation();

  return (
    <BoxContainer>
      <div>
        <Text className="text-xl text-black/40 font-bold">{t("pickerError.title")}</Text>
        <div className="pt-2.5">
          <Text className="text-base text-black/40">{t("pickerError.description")}</Text>
        </div>
      </div>
    </BoxContainer>
  );
}
